import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function GenderCard() {
  const [distribution, setDistribution] = useState({
    female: 0,
    male: 0,
    other: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadGenderData() {
      try {
        const snap = await getDocs(collection(db, "users"));

        let female = 0;
        let male = 0;
        let other = 0;

        snap.forEach((doc) => {
          const g = (doc.data().gender || "").toLowerCase().trim();

          if (g === "feminino") female++;
          else if (g === "masculino") male++;
          else other++;
        });

        const total = female + male + other;

        setDistribution({
          female: total ? Math.round((female / total) * 100) : 0,
          male: total ? Math.round((male / total) * 100) : 0,
          other: total ? Math.round((other / total) * 100) : 0,
        });
      } catch (error) {
        console.error("Erro ao carregar distribuição de gênero:", error);
      } finally {
        setLoading(false);
      }
    }

    loadGenderData();
  }, []);

  if (loading) {
    return (
      <div className="metric-card">
        <p className="metric-label">Distribuição por gênero</p>
        <p className="metric-value">Carregando...</p>
        <span className="metric-tag">Base atual</span>
      </div>
    );
  }

  return (
    <div className="metric-card">
      <p className="metric-label">Distribuição por gênero</p>

      <div className="metric-list">
        <div className="metric-list-item">
          <span className="bullet female"></span> Feminino: {distribution.female}%
        </div>

        <div className="metric-list-item">
          <span className="bullet male"></span> Masculino: {distribution.male}%
        </div>

        <div className="metric-list-item">
          <span className="bullet other"></span> Outros: {distribution.other}%
        </div>
      </div>

      <span className="metric-tag">Base atual</span>
    </div>
  );
}
